import Phone from '../../src/legacy/Phone.tsx';
export default Phone;
